export default __webpack_public_path__ + "static/top_flow_img-796e8127c3fca79fc7e0ab5c28b5659d.jpg";